export function parseText(text: string) {
    return text.replace(/{br}/g, `<br/>`);
}
